<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <PositionForm :formProps="formProps">
                </PositionForm>
            </template>
            <template #search="searchProps">
                <PositionSearch :searchProps="searchProps">
                </PositionSearch>
            </template>
        </v-view>
    </div>

</template>

<script setup>
import { ref } from "vue";
import PositionForm from './PositionForm.vue'
import PositionSearch from './PositionSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __, getFromRoute, screenMessage, getTimeouts } from '@pages/Helper/utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const isLoading = ref(false)

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
